import Loader from 'components/Loader';
import { useRafLink } from 'hooks';

function Signup() {
  useRafLink();

  window.location.replace('/');

  return <Loader />;
}

export default Signup;
